import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import client from './modules/client'
import addresses from './modules/addresses'
import rents from './modules/rents'
import rentPreRegistrations from './modules/rent_pre_registrations'
import neighborhoods from './modules/neighborhoods'
import references from './modules/references'
import companies from './modules/companies'
import employees from './modules/employees'
import plans from './modules/plans'
import subcategories from './modules/subcategories'
import products from './modules/products'
import skus from './modules/skus'
import companySkus from './modules/company_skus'
import companySkuIdentifiers from './modules/company_sku_identifiers'
import maintenances from './modules/maintenances'
import transports from './modules/transports'
import invoices from './modules/invoices'
import accounts from './modules/accounts'
import accessories from './modules/accessories'
import contacts from './modules/contacts'
import restrictions from './modules/restrictions'
import companyClients from './modules/company_clients'
import companyClientReviews from './modules/company_client_reviews'
import companySettings from './modules/company_settings'
import announcements from './modules/announcements'
import brands from './modules/brands'
import cities from './modules/cities'
import certificates from './modules/certificates'
import uploadClientPjFile from './modules/upload_client_pj_file'
import rentPreRegistrationChatMessage from './modules/rent_pre_registration_chat_message'
import rentPreRegistrationChatMessageView from './modules/rent_pre_registration_chat_message_view'
import rentPreRegistrationChat from './modules/rent_pre_registration_chat'
import loyaltyAgreements from './modules/loyalty_agreements'
import comboExtract from './modules/combo_extract'
import judicialLawsuits from './modules/judicial_lawsuits'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  state,
  actions,
  getters,
  mutations,
  modules: {
    client,
    addresses,
    rents,
    rentPreRegistrations,
    neighborhoods,
    references,
    companies,
    employees,
    plans,
    subcategories,
    products,
    skus,
    companySkus,
    companySkuIdentifiers,
    maintenances,
    transports,
    invoices,
    accounts,
    accessories,
    contacts,
    restrictions,
    companyClients,
    companyClientReviews,
    companySettings,
    announcements,
    brands,
    cities,
    certificates,
    uploadClientPjFile,
    rentPreRegistrationChatMessage,
    rentPreRegistrationChatMessageView,
    rentPreRegistrationChat,
    loyaltyAgreements,
    comboExtract,
    judicialLawsuits
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js